package com.vizio.redwolf.utils.clientprovider

import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.DefaultRequest
import io.ktor.client.plugins.cookies.AcceptAllCookiesStorage
import io.ktor.client.plugins.cookies.HttpCookies

object CookieClientProvider : ConfigurableClientProvider() {

    override val lazyClientInitDelegate: Lazy<HttpClient> = lazy {
        val clientConfig: HttpClientConfig<*>.() -> Unit = {
            installCoreClientConfig()
            install(HttpCookies) {
                // Will keep an in-memory map with all the cookies from previous requests.
                storage = AcceptAllCookiesStorage()
            }
            install(DefaultRequest) {
                addSdkHeaders()
                addCredentialsInclude()
            }
        }
        HttpClient(clientConfig)
    }

    override val httpClient: HttpClient by lazyClientInitDelegate

    override fun close() {
        httpClient.close()
    }

}
